var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrucks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 21,
    viewBox: "0 0 31 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3765 16.5881H30.1953V3.66473C30.1953 2.52244 30.1953 2.26953 29.1763 2.26953H13.1834C13.0096 2.26953 12.8686 2.64006 12.8686 3.0967C12.8686 3.55333 13.3765 16.5881 13.3765 16.5881Z",
    fill: "url(#paint0_linear_6779_9941)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41763 2.96484H10.7245C10.8614 2.96484 10.9727 3.07499 10.9727 3.2106V8.32201C10.9727 8.45763 10.8614 8.56777 10.7245 8.56777H1.44638",
    stroke: "#0066FF",
    strokeWidth: 0.685376,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8887 1H7.03892C6.8957 1 6.76152 1.06884 6.67948 1.18518L1.07995 9.08532C1.02781 9.15829 1 9.24572 1 9.33521V15.7043C1 15.9446 1.19676 16.1394 1.4394 16.1394H13.3281V1.43507C13.3281 1.19482 13.1314 1 12.8887 1Z",
    stroke: "black",
    strokeWidth: 0.685376,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6078 20.0338C21.7279 20.0338 20.2039 18.5248 20.2039 16.6634C20.2039 14.802 21.7279 13.293 23.6078 13.293C25.4877 13.293 27.0117 14.802 27.0117 16.6634C27.0117 18.5248 25.4877 20.0338 23.6078 20.0338Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.685376,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.90076 20.0338C6.02082 20.0338 4.49683 18.5248 4.49683 16.6634C4.49683 14.802 6.02082 13.293 7.90076 13.293C9.78069 13.293 11.3047 14.802 11.3047 16.6634C11.3047 18.5248 9.78069 20.0338 7.90076 20.0338Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.685376,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89637 18.0355C7.13153 18.0355 6.5115 17.4215 6.5115 16.6642C6.5115 15.9069 7.13153 15.293 7.89637 15.293C8.66122 15.293 9.28125 15.9069 9.28125 16.6642C9.28125 17.4215 8.66122 18.0355 7.89637 18.0355Z",
    fill: "#0066FF",
    stroke: "#0066FF",
    strokeWidth: 0.685376,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6073 18.0355C22.8425 18.0355 22.2224 17.4215 22.2224 16.6642C22.2224 15.9069 22.8425 15.293 23.6073 15.293C24.3722 15.293 24.9922 15.9069 24.9922 16.6642C24.9922 17.4215 24.3722 18.0355 23.6073 18.0355Z",
    fill: "#0066FF",
    stroke: "#0066FF",
    strokeWidth: 0.685376,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6779_9941",
    x1: 21.5319,
    y1: 2.26953,
    x2: 21.5319,
    y2: 16.5881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68BBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B8AFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrucks);
export default __webpack_public_path__ + "static/media/Trucks.da54185b9172e995c8b7e29895ccbe3b.svg";
export { ForwardRef as ReactComponent };